/**
 * Theme plugin — runs once on client init.
 *
 * Two responsibilities:
 *   1. Apply the `dark` class to <html> immediately (before Vue mounts)
 *      so visitors don't see a light-mode flash if their preference is dark.
 *   2. Sync the `useTheme()` composable's `isDark` state to the actual
 *      preference, so the toggle icon and the first toggle click both
 *      reflect reality.
 *
 * Without (2) the toggle has a "first click does nothing visible" bug:
 *   - Plugin sets <html class="dark"> based on localStorage='dark'
 *   - useState('theme-dark') initializes to its default `false`
 *   - First toggle click flips state false→true, then updateTheme()
 *     adds the dark class (already there) → no visual change
 *   - Second click finally removes the class → finally light mode
 */
export default defineNuxtPlugin(() => {
  const { initTheme } = useTheme()
  initTheme()
})
